/**
 * 적요 → 계정 학습/추천용 키워드 정제.
 * 백엔드 bankbookModel.cleanMemoKeyword 와 동일해야 한다.
 */
export function cleanBankbookMemoKeyword(memo: string | null | undefined): string {
  if (!memo) return '';
  return String(memo)
    .replace(/\d{2,4}[-/.]\d{1,2}[-/.]\d{1,2}/g, '')
    .replace(/\d+/g, '')
    .replace(/[^\w\sㄱ-ㅎㅏ-ㅣ가-힣]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export interface BankbookLearnItemInput {
  memo?: string | null;
  gubun: string;
  scode: string;
}

/**
 * 계정 지정 성공 건에서 학습 API용 항목을 만든다. (동일 키워드·계정은 1건으로 합침)
 * 빈 적요·너무 짧은 정제키워드·scode 없음은 제외.
 */
export function buildBankbookLearnItems(params: {
  mCode: string | number;
  bizGubun?: string | null;
  items: BankbookLearnItemInput[];
}): Array<{
  m_code: string | number;
  biz_gubun?: string;
  gubun: string;
  keyword: string;
  scode: string;
}> {
  const { mCode, bizGubun, items } = params;
  const seen = new Set<string>();
  const out: Array<{
    m_code: string | number;
    biz_gubun?: string;
    gubun: string;
    keyword: string;
    scode: string;
  }> = [];

  for (const item of items) {
    const scode = String(item.scode || '').trim();
    const gubun = String(item.gubun || '').trim();
    const keyword = cleanBankbookMemoKeyword(item.memo);
    if (!scode || !gubun || keyword.length < 2) continue;
    const key = `${gubun}|${keyword}|${scode}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({
      m_code: mCode,
      ...(bizGubun ? { biz_gubun: bizGubun } : {}),
      gubun,
      keyword,
      scode,
    });
  }
  return out;
}
